import React, { useEffect, useState } from 'react'

import './MemoryMatchResultsOverlay.scss'

const MemoryMatchResultsOverlay = ({ results, isOpen, setIsOpen }) => {
  const [title, setTitle] = useState(null)
  const [body, setBody] = useState(null)
  const closeModal = () => {
    setIsOpen(false)
  }

  useEffect(() => {
    let possibleMatches = Math.ceil(results.totalCards / 2)
    let matches = Math.ceil(results.cardsCleared / 2)

    let winAmount = Math.ceil(possibleMatches * 0.6)
    console.log(results, possibleMatches, matches, winAmount)
    if (matches >= winAmount) {
      if (matches === possibleMatches) {
        //perfect game
        setTitle('Well Done!')
        setBody(`You got ${matches} out of ${possibleMatches} matches!`)
      } else {
        setTitle('Well Done!')
        setBody(`You got ${matches} out of ${possibleMatches} matches!`)
      }
    } else {
      setTitle('Better Luck Next Time!')
      if (results.cardsCleared === 0) {
        setBody(`You didn't get any matches!`)
      } else {
        setBody(`You got ${matches} out of ${possibleMatches} matches.`)
      }
    }
  }, [results])
  return (
    <>
      <div
        className={`memory-match-results-overlay ${isOpen ? `is-active` : ``}`}
      >
        <div className={`modal-wrap`}>
          {/*    <button
              className={`x-button
            `}
              onClick={closeModal}
              aria-label="Close"></button> */}
          {title !== null && <h2 className="modal-title">{title}</h2>}
          {body !== null && <p className="modal-description">{body}</p>}
        </div>
      </div>
    </>
  )
}
export default MemoryMatchResultsOverlay
